export default __webpack_public_path__ + "static/media/person_1@3x.359c8996.png";